import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { MutationKey } from '@shared/config';
import { vacancyApi } from '../vacancyApi';
import {
  type CreateVacanciesTemplateRequest,
  type VacancyTemplate,
} from '../types';
import type { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';

export const useCreateVacancyTemplate = (): UseMutationResult<
  VacancyTemplate,
  AxiosError<TFormErrorResponse>,
  CreateVacanciesTemplateRequest
> => {
  return useMutation({
    mutationKey: [MutationKey.CREATE_VACANCY_TEMPLATE],
    mutationFn: (data: CreateVacanciesTemplateRequest) =>
      vacancyApi.createVacanciesTemplate(data),
  });
};
